/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-fin-voice */
import templateOnlyComponent from '@ember/component/template-only';

export interface HeaderArgs {
  title: string;
  openNewLineModal: () => void;
  openPhoneSettings: () => void;
  openHelpArticle: () => void;
  settingsDisabled: boolean;
}

interface Signature {
  Args: HeaderArgs;
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const Header = templateOnlyComponent<Signature>();
export default Header;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Deploy::Voice::Header': typeof Header;
  }
}
